import CaptchaProvider from './CaptchaProvider';

export default class HCaptchaProvider extends CaptchaProvider {
    constructor(element, verifyCallback, config = {}) {
        super(element, verifyCallback, config);
        this.sitekey = config.sitekey;
        this.scriptLoaded = false;
        this.slug = null;
        this.chToken = null;
    }

    async initialize(slug, chToken) {
        this.slug = slug;
        this.chToken = chToken;
        
        if (!this.scriptLoaded) {
            await this.injectScripts();
            this.scriptLoaded = true;
        }
    }

    injectScripts() {
        return new Promise((resolve) => {
            const body = document.getElementsByTagName('body')[0];
            
            const callbackScript = document.createElement('script');
            const scriptContent = document.createTextNode(`var onloadCallback = window.ChCaptcha.hcaptchaOnloadCallback;`);
            callbackScript.appendChild(scriptContent);
            
            const hcaptchaScript = document.createElement('script');
            hcaptchaScript.async = true;
            hcaptchaScript.defer = true;
            hcaptchaScript.src = 'https://js.hcaptcha.com/1/api.js?onload=onloadCallback&render=explicit';
            
            window.ChCaptcha = window.ChCaptcha || {};
            window.ChCaptcha.hcaptchaOnloadCallback = () => {
                this.render();
                resolve();
            };
            
            body.appendChild(callbackScript);
            body.appendChild(hcaptchaScript);
        });
    }

    async render() {
        if (!window.hcaptcha) {
            console.error('hCaptcha library not loaded');
            return;
        }

        this.widgetId = window.hcaptcha.render(this.element, {
            'sitekey': this.sitekey,
            'callback': (response) => this.verify(response)
        });
    }

    async reset() {
        // Don't reset if already validated to avoid hCaptcha timeout errors
        if (this.isValidated) {
            return;
        }
        
        if (window.hcaptcha && this.widgetId !== null) {
            try {
                window.hcaptcha.reset(this.widgetId);
            } catch (error) {
                // Silently catch reset errors which can occur if widget is already reset
                console.debug('hCaptcha reset error (safe to ignore):', error);
            }
        }
        
        this.isValidated = false;
        this.token = null;
    }

    destroy() {
        super.destroy();
        if (window.hcaptcha && this.widgetId !== null) {
            window.hcaptcha.reset(this.widgetId);
        }
    }
}